module.exports = __webpack_public_path__ + "static/media/Barmag 2a.490d9df3.jpg";